// Detect iframe embed mode via ?embed=1, persist in sessionStorage so
// it survives client-side route changes that drop the query string.
const KEY = "lm-embed-mode";

export function initEmbedMode() {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("embed") === "1") {
      window.sessionStorage.setItem(KEY, "1");
    }
  } catch {
    // ignore
  }
  const on = window.sessionStorage.getItem(KEY) === "1";
  if (on) document.documentElement.classList.add("embed");
  return on;
}

export function isEmbedMode() {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(KEY) === "1";
}
